import { render, staticRenderFns } from "./addBt.vue?vue&type=template&id=b1abcfca&scoped=true&"
import script from "./addBt.vue?vue&type=script&lang=js&"
export * from "./addBt.vue?vue&type=script&lang=js&"
import style0 from "./addBt.vue?vue&type=style&index=0&id=b1abcfca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1abcfca",
  null
  
)

export default component.exports